import { render, staticRenderFns } from "./score-widget.vue?vue&type=template&id=42190a4d"
import script from "./score-widget.vue?vue&type=script&lang=js"
export * from "./score-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports